import { Box, Typography } from '@mui/material'
import { EXTERNAL_LINKS } from '~/lib/externalLinks'
import React from 'react'

export const TermsText = () => {
  return (
    // 親に対して自身をセンタリングさせるためのdisplay="flex"
    <Box color="#838383" display="flex">
      <Typography variant="caption" sx={{ wordBreak: 'keep-all' }}>
        <a href={EXTERNAL_LINKS.PRIVACY_POLICY} target="_blank" rel="noreferrer">
          プライバシーポリシー
        </a>
        、
        <a href={EXTERNAL_LINKS.TERMS_OF_SERVICE} target="_blank" rel="noreferrer">
          利用規約
        </a>
        に同意して利用する
      </Typography>
    </Box>
  )
}
